"use strict";

(function ready() {

	var _polyfills = require('./polyfills');
	var _extendStandartPrototypes = require('./extendStandartPrototypes');
	var CustomSelect = require('./customSelect');
	var SimpleMenu = require('./simpleMenu');
	var SimpleVerticalSlider = require('./simpleVerticalSlider');
	var SliderWithControlls = require('./slider-sliderWithControlls');
	var LangSwitcher = require('./langSwitcher');
	var Popup = require('./popup');
	var ContactFormController = require('./contactFormController');

	_polyfills.init();
	_extendStandartPrototypes.init();

	var headerElem = document.querySelector('#header');
	if (headerElem) {
		var header = new SimpleMenu({
			elem: headerElem,
			openBtn: document.querySelector('#header_menu_open_btn'),
			closeBtn: document.querySelector('#header_menu_close_btn')
		});
	}

	var langSelectElemsArr = [];

	var langSelectHeaderElem = document.querySelector('#lang_switch_header');
	if (langSelectHeaderElem) {
		var langSelectHeader = new CustomSelect({
			elem: langSelectHeaderElem
		});

		langSelectElemsArr.push(langSelectHeaderElem);
	}

	var langSelectFooterElem = document.querySelector('#lang_switch_footer');
	if (langSelectFooterElem) {
		var langSelectFooter = new CustomSelect({
			elem: langSelectFooterElem
		});

		langSelectElemsArr.push(langSelectFooterElem);
	}

	var langSwitcher = new LangSwitcher({
		langSelectElemsArr: langSelectElemsArr
	});

	var productSliderElem = document.querySelector('#product_vertical_slider');
	if (productSliderElem) {
		 var customMoveCheck = function(self, slideIndex, slidesArr, mainElem) {
			if (mainElem.classList.contains('text_slider_transition')) {
				return false;
			}
			return true;
		};

		var imageSlider = new SimpleVerticalSlider({
			elem: productSliderElem,
			transitionDuration: 0.5,
			overflowHiddenContainerSelector: '.image_overflow_hidden_container',
			overflowContainerSelector: '.image_overflow_block',
			slideSelector: '.image_slide',
			transitionTopWidthArr: ['md', 'lg'],
			transitionOpacityWidthArr: ['sm'],
			transitionInProcessClass: 'image_slider_transition',
			controllsSelector: '',
			customMoveCheck: customMoveCheck
		});

		var textSlider = new SimpleVerticalSlider({
			elem: productSliderElem,
			transitionDuration: 0.5,
			overflowHiddenContainerSelector: '.text_overflow_hidden_container',
			overflowContainerSelector: '.text_overflow_block',
			slideSelector: '.text_slide',
			transitionTopWidthArr: [],
			transitionOpacityWidthArr: ['sm', 'md', 'lg'],
			transitionInProcessClass: 'text_slider_transition',
			controllsSelector: '',
			customMoveCheck: customMoveCheck
		});
	}

	var feedbackSliderElem = document.querySelector('#feedback_slider');
	if (feedbackSliderElem) {
		var feedbackSlider = new SliderWithControlls({
			elem: feedbackSliderElem,
			delay: 5000,
			breakPoint: 0,
			controllsSelector: '#page_slide5_slider_controlls'
		});
	}

	var registrationFormPopupElem = document.querySelector('#registration_form_popup');
	if (registrationFormPopupElem) {
		var registrationFormPopup = new Popup({
			elem: registrationFormPopupElem,
			popupOpenBtnSelector: '[data-popup-action="open"]',
			popupCloseBtnSelector: '[data-popup-action="close"]'
		});
	}

	var thanksFormPopupElem = document.querySelector('#thanks_popup');
	if (thanksFormPopupElem) {
		var thanksFormPopup = new Popup({
			elem: thanksFormPopupElem,
			popupOpenBtnSelector: '[data-popup-action="open"]',
			popupCloseBtnSelector: '[data-popup-action="close"]'
		});
	}

	var registrationFormElem = document.querySelector('#registration_from');
	if (registrationFormElem) {
		var registrationForm = new ContactFormController({
			elem: registrationFormElem,
			actionUrl: registrationFormElem.action,
			method: registrationFormElem.method,
			callback: function(self) {
				self._sendCustomEvent(document, 'closePopup', { bubbles: true, detail: { targetPopupElem: registrationFormPopupElem } });
				if (thanksFormPopup) {
					self._sendCustomEvent(document, 'openPopup', { bubbles: true, detail: { targetPopupElem: thanksFormPopupElem } });
				}
			}
		});
	}

})();



//////////////////
// WEBPACK FOOTER
// ./dev/scripts/page.js
// module id = 0
// module chunks = 0